import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Papa from "papaparse";
import React, { useEffect, useRef, useState } from "react";
import { adminReqConfig, api } from "../../include/api";
import {
  CustomColoredDropdown,
  CustomDropdown,
  formatMonthDateYear,
  formatShortMonthDateYearWithTime,
  getAdmin,
} from "../../include/function";
import "../../styles/Super.css";
import AdminHeader from "./Header";
import { ChevronDown } from "react-feather";
import { useNotification } from "../../Toast/ToastProvider";
import { useNavigate } from "react-router-dom";
import { ERROR, SUCCESS } from "../../include/constant";

const CustomerOrders = ({ customerId }) => {
  const user = getAdmin();
  const [fetchLoading, setFetchLoading] = useState(true);
  const [orderData, setOrderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const toast = useNotification();
  const [selectedData, setSelectedData] = useState([]);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [convertingOrderId, setConvertingOrderId] = useState(null);

  const navigate = useNavigate();

  //Filter options from API
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);

  //Filter values (all optional)
  const [filterValues, setFilterValues] = useState({
    date: "",
    status: "",
    paymentType: "",
    paymentStatus: "",
    customerType: "",
    productId: "",
    brandId: "",
    categoryId: "",
    timePeriod: "",
    fromDate: "",
    toDate: "",
  });


  //Fetch filter options on mount
  useEffect(() => {
    api
      .get("/brand/", adminReqConfig())
      .then((res) => setBrands(res.data.data || []))
      .catch(() => setBrands([]));

    api
      .get("/category/?flag=exceptHome", adminReqConfig())
      .then((res) => setCategories(res.data.data || []))
      .catch(() => setCategories([]));

    api
      .get("/product/?limit=200", adminReqConfig())
      .then((res) => setProducts(res.data.data || []))
      .catch(() => setProducts([]));
  }, []);

  const handleOrderDetailClick = (orderId) => {
    navigate(`/admin/order-details/${orderId}`);
  };

  //Fetch orders with filters
  const getOrders = (filters = {}) => {
    setFetchLoading(true);

      const params = new URLSearchParams();
       if (customerId) {
         params.set("customerId", customerId);
       } 

    // Add non-empty filters
    if (filters.date) params.set("date", filters.date);
    if (filters.fromDate) params.set("fromDate", filters.fromDate);
    if (filters.toDate) params.set("toDate", filters.toDate);
    if (filters.status) params.set("status", filters.status);
    if (filters.paymentStatus)
      params.set("paymentStatus", filters.paymentStatus);
    if (filters.paymentType) params.set("paymentType", filters.paymentType);
    if (filters.customerType) params.set("customerType", filters.customerType);
    if (filters.productId) params.set("productId", filters.productId);
    if (filters.brandId) params.set("brandId", filters.brandId);
    if (filters.categoryId) params.set("categoryId", filters.categoryId);
    if (filters.reviewFilter) params.set("reviewFilter", filters.reviewFilter);

    const url = `/orders/?${params.toString()}`;

    api
      .get(url, adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          const normalizedData = response.data.data.map((order) => ({
            ...order,
            orderItems: order.orderItems.map((item) => ({
              ...item,
              status: item.status?.toLowerCase(),
            })),
          }));
          setOrderData(normalizedData);
          setFilteredData(normalizedData);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch orders:", error);
        setOrderData([]);
        setFilteredData([]);
      })
      .finally(() => setFetchLoading(false));
  };

     // when filter category choose particular brand and product logic ---start---
      const [filteredBrands, setFilteredBrands] = useState([]);
      const [filteredProducts, setFilteredProducts] = useState([]);
  
      const handleFilterChange = (key, value) => {
        setFilterValues((prev) => {
          const newFilters = { ...prev, [key]: value };
  
          if (key === "categoryId") {
            newFilters.brandId = "";
            newFilters.productId = "";
          } else if (key === "brandId") {
            newFilters.productId = "";
          }
  
          return newFilters;
        });
      };
      useEffect(() => {
        if (filterValues.categoryId) {
          const categoryBrands = brands.filter(
            (brand) =>
              brand.categoryId?.toString() === filterValues.categoryId.toString(),
          );
          setFilteredBrands(categoryBrands);
        } else {
          setFilteredBrands(brands); // Show all brands if no category selected
        }
      }, [filterValues.categoryId, brands]);
      useEffect(() => {
        let filtered = products;
        if (filterValues.brandId) {
          filtered = filtered.filter(
            (product) =>
              product.brandId?.toString() === filterValues.brandId.toString(),
          );
        }
        setFilteredProducts(filtered);
      }, [filterValues.categoryId, filterValues.brandId, products]);
    useEffect(() => {
       api
         .get("/category/?flag=exceptHome", adminReqConfig())
         .then((res) => setCategories(res.data.data || []))
         .catch(() => setCategories([]));
      api
        .get("/brand/", adminReqConfig())
        .then((res) => setBrands(res.data.data || []))
        .catch(() => setBrands([]));
  
  
      api
        .get("/product/?limit=200", adminReqConfig())
        .then((res) => setProducts(res.data.data || []))
        .catch(() => setProducts([]));
    }, []);
            // ------end-------

  //Initial load
  useEffect(() => {
    getOrders();
  }, []);

  //Search
  useEffect(() => {
    let filtered = orderData;
    if (searchQuery.trim()) {
      filtered = filtered.filter(
        (order) =>
          order.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          order.orderItems.some((item) =>
            item.productName?.toLowerCase().includes(searchQuery.toLowerCase())
          )
      );
      setCurrentPage(1);
    }
    setFilteredData(filtered);
  }, [searchQuery, orderData]);

  //Pagination logic
  let currentItems = [];
  let totalPage = 1;
  let showingFrom = 0;
  let showingTo = 0;
  if (itemsPerPage === "all") {
    currentItems = filteredData;
    showingFrom = filteredData.length > 0 ? 1 : 0;
    showingTo = filteredData.length;
  } else {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    totalPage = Math.ceil(filteredData.length / itemsPerPage);
    showingFrom = indexOfFirstItem + 1;
    showingTo = Math.min(indexOfLastItem, filteredData.length);
  }

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //Close filter panel on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isFilterPanelOpen && !e.target.closest(".nav-item")) {
        setIsFilterPanelOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isFilterPanelOpen]);

  //Row expand/collapse
  const toggleExpand = (orderId) => {
    setExpandedRows((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  //Export handlers (CSV)
  const handleDownloadCSV = () => {
    const dataToExport =
      selectedData.length > 0
        ? orderData.filter((order) => selectedData.includes(order.id))
        : orderData;

    if (dataToExport.length === 0) {
      toast({ type: "error", message: "No order data to download" });
      return;
    }

    const csvRows = [];
    let serialNo = 1;

    dataToExport.forEach((order) => {
      const baseOrderInfo = {
        "S.No": serialNo,
        "Order ID": order.id || "-",
        "Customer ID": order.customerId || "-",
        "Customer Name": order.name || "-",
        "Customer Type": order.customerType || "-",
        Phone: order.phoneNumber || "-",
        "Alternate Phone": order.alternatePhoneNumber || "-",
        Email: order.emailId || "-",
        "Order Date": order.createTimestamp
          ? new Date(order.createTimestamp).toLocaleString("en-IN")
          : "-",

        // Delivery Address
        "Delivery Address": order.address || "-",
        "Delivery Locality": order.locality || "-",
        "Delivery Landmark": order.landmark || "-",
        "Delivery City": order.city || "-",
        "Delivery State": order.state || "-",
        "Delivery Pin": order.pin || "-",
        "Address Type": order.addressType || "-",

        // Billing Address (may differ)
        "Billing Address": order.billAddress || "-",
        "Billing Locality": order.billLocality || "-",
        "Billing Landmark": order.billLandmark || "-",
        "Billing City": order.billCity || "-",
        "Billing State": order.billState || "-",
        "Billing Pin": order.billPin || "-",
        "Billing GST": order.billGst || "-",

        // Order Totals
        "Total Items": order.totalItems || 0,
        "Total Amount": order.totalAmount || 0,
        "Total Discount": order.totalDiscount || 0,
        "Total Delivery Charge": order.totalDeliveryCharge || 0,
        "Bill Amount": order.billAmount || 0,
        "Total Points": order.totalPoints || 0,

        // Payment Info
        "Payment Mode": order.orderItems?.[0]?.paymentMode || "-",
        "Payment Status":order.paymentStatus || "-",
        "Payment Info": order.orderItems?.[0]?.paymentInfo || "-",
      };

      if (!order.orderItems || order.orderItems.length === 0) {
        // Order with no items → export header only
        csvRows.push({
          ...baseOrderInfo,
          // Item fields empty
          "Item ID": "",
          "Product ID": "",
          "Product Name": "",
          Variant: "",
          Unit: "",
          Qty: "",
          "Price per Unit": "",
          "Item Amount": "",
          "Discount Mode": "",
          "Discount Value": "",
          "Discount Label": "",
          "Points Earned": "",
          "Main Image URL": "",
          "Item Status": "",
          "Shop ID": "",
        });
        serialNo++;
      } else {
        order.orderItems.forEach((item) => {
          csvRows.push({
            ...baseOrderInfo,

            // Override S.No per item
            "S.No": serialNo++,

            // Item-specific fields
            "Item ID": item.id || "-",
            "Product ID": item.productId || "-",
            "Product Name": item.productName || "-",
            Variant: item.variant || "-",
            Unit: item.unit || "-",
            Qty: item.qty || 0,
            "Price per Unit": item.price || 0,
            "Item Amount": item.amount || 0,
            "Discount Mode": item.discountMode || "-",
            "Discount Value": item.discountValue || 0,
            "Discount Label": item.discountLabel || "-",
            "Points Earned": item.points || 0,
            "Main Image URL": item.mainImage || "-",
            "Item Status": item.status || "-",
            "Shop ID": item.shopId || "-",
          });
        });
      }
    });

    const columns = [
      "S.No",
      "Order ID",
      "Customer ID",
      "Customer Name",
      "Customer Type",
      "Phone",
      "Alternate Phone",
      "Email",
      "Order Date",

      // Delivery Address
      "Delivery Address",
      "Delivery Locality",
      "Delivery Landmark",
      "Delivery City",
      "Delivery State",
      "Delivery Pin",
      "Address Type",

      // Billing Address
      "Billing Address",
      "Billing Locality",
      "Billing Landmark",
      "Billing City",
      "Billing State",
      "Billing Pin",
      "Billing GST",

      // Order Totals
      "Total Items",
      "Total Amount",
      "Total Discount",
      "Total Delivery Charge",
      "Bill Amount",
      "Total Points",

      // Payment
      "Payment Mode",
      "Payment Status",
      "Payment Info",

      // Item
      "Item ID",
      "Product ID",
      "Product Name",
      "Variant",
      "Unit",
      "Qty",
      "Price per Unit",
      "Item Amount",
      "Discount Mode",
      "Discount Value",
      "Discount Label",
      "Points Earned",
      "Main Image URL",
      "Item Status",
      "Shop ID",
    ];

    const csv = Papa.unparse({
      fields: columns,
      data: csvRows.map((row) => columns.map((col) => row[col])),
    });

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "orders_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  //Selection handlers
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = currentItems.map((p) => p.id);
      setSelectedData((prev) => [...new Set([...prev, ...allIds])]);
    } else {
      const idsToRemove = currentItems.map((p) => p.id);
      setSelectedData((prev) => prev.filter((id) => !idsToRemove.includes(id)));
    }
  };
  const handleSelectOne = (id) => {
    setSelectedData((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  //Apply & Clear filters
  const applyFilters = () => {
    let finalFilters = { ...filterValues };

    // Handle timePeriod presets
    if (filterValues.timePeriod && filterValues.timePeriod !== "period") {
      const now = new Date();
      let fromDate = "";
      let toDate = "";

      switch (filterValues.timePeriod) {
        case "today":
          fromDate = toDate = now.toISOString().split("T")[0];
          break;
        case "yesterday":
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          fromDate = toDate = yesterday.toISOString().split("T")[0];
          break;
        case "thisMonth":
          fromDate = `${now.getFullYear()}-${String(
            now.getMonth() + 1
          ).padStart(2, "0")}-01`;
          toDate = now.toISOString().split("T")[0];
          break;
        case "last3Months":
          const threeMonthsAgo = new Date(now);
          threeMonthsAgo.setMonth(now.getMonth() - 3);
          fromDate = threeMonthsAgo.toISOString().split("T")[0];
          toDate = now.toISOString().split("T")[0];
          break;
        case "thisYear":
          fromDate = `${now.getFullYear()}-01-01`;
          toDate = `${now.getFullYear()}-12-31`;
          break;
        case "all":
        default:
          fromDate = toDate = "";
      }

      finalFilters = {
        ...finalFilters,
        fromDate,
        toDate,
      };
    }

    // Clear the old `date` filter if using range
    if (finalFilters.timePeriod) {
      finalFilters.date = ""; // because backend uses either `date` OR `fromDate/toDate`
    }

    getOrders(finalFilters);
    setIsFilterPanelOpen(false);
  };
  const clearFilters = () => {
    const empty = {
      date: "",
      fromDate: "",
      toDate: "",
      status: "",
      paymentType: "",
      paymentStatus: "",
      customerType: "",
      productId: "",
      brandId: "",
      categoryId: "",
      timePeriod: "",
    };
    setFilterValues(empty);
    getOrders(empty);
    setIsFilterPanelOpen(false);
  };

  //Dropdown options
  const PAYMENT_OPTIONS = [
    { value: "paid", label: "Paid" },
    { value: "pending", label: "Unpaid" },
    { value: "partially paid", label: "Partially Paid" },
  ];



  const STATUS_OPTIONS = [
    { value: "ordered", label: "Recieved" },
    { value: "confirmed", label: "Confirmed" },
    { value: "packed", label: "Packed" },
    { value: "shipped", label: "Shipped" },
    { value: "delivered", label: "Delivered" },
    { value: "return", label: "Return" },
    { value: "cancelled", label: "Cancelled" },
  ];

  const formatOrderId = (order) => {
    if (!order?.createTimestamp || !order?.id) return "ORD--";

    // Extract last 2 digits of year
    const year = new Date(order.createTimestamp).getFullYear();
    const yy = String(year).slice(-2); // e.g., 2025 → "25"

    // Zero-pad order.id to 4 digits
    const paddedId = String(order.id).padStart(4, "0"); // e.g., 7 → "0007"

    return `ORD${yy}-${paddedId}`;
  };

  return (
    <>
      <div className="content-wrapper p-0">
        <section
          style={{
            backgroundColor: "#F1F4F9",
            marginBottom: "40px",
            minHeight: "80vh",
          }}
        >
          <>
            <div className="rounded-5 bg-white py-24">
              <div className="row align-items-center px-24 py-10 mb-3">
                <div className="col-md-2">
                  <h6 className="fs-6 mb-0">Orders List</h6>
                </div>
                <div className="col-md-7 d-flex align-items-center">
                  <div
                    className="nav-item w-100"
                    style={{ position: "relative" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #c6d6f5",
                        borderRadius: "8px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <img
                        src="/assets/images/search-icon.png"
                        style={{ width: "18px", marginLeft: "8px" }}
                      />
                      <input
                        type="text"
                        placeholder="Filter and search here..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onFocus={() => setIsFilterPanelOpen(true)}
                        style={{
                          border: "none",
                          outline: "none",
                          padding: "8px 8px",
                          width: "100%",
                          fontSize: "14px",
                          color: "#333",
                          backgroundColor: "transparent",
                        }}
                      />
                      <ChevronDown
                        size={16}
                        style={{
                          marginRight: "8px",
                          color: "#999",
                          cursor: "pointer",
                          transform: isFilterPanelOpen
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                          transition: "transform 0.2s",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsFilterPanelOpen(!isFilterPanelOpen);
                        }}
                      />
                    </div>
                    {isFilterPanelOpen && (
                      <FilterPanel
                        filterValues={filterValues}
                        onFilterChange={(key, value) =>
                          setFilterValues((prev) => ({
                            ...prev,
                            [key]: value,
                          }))
                        }
                        onApply={applyFilters}
                        onClear={clearFilters}
                        brands={brands}
                        categories={categories}
                        products={products}
                        filteredBrands={filteredBrands}
                        filteredProducts={filteredProducts}
                      />
                    )}
                  </div>
                </div>
                <div className="d-flex col-md-2">
                  <CustomDropdown handleDownloadCSV={handleDownloadCSV} />
                </div>
              </div>

              {/* Table */}
              <div className="table-responsive mt-24 product-table">
                <table className="table table-striped custom-striped-table-product-list align-middle">
                  <thead>
                    <tr>
                      <th scope="col">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ borderColor: "#c5d5f5" }}
                          onChange={handleSelectAll}
                          checked={
                            currentItems.length > 0 &&
                            currentItems.every((p) =>
                              selectedData.includes(p.id),
                            )
                          }
                        />
                      </th>
                      <th
                        scope="col"
                        style={{ fontSize: "15px", textWrap: "nowrap" }}
                      >
                        Order ID
                      </th>
                      <th
                        scope="col"
                        style={{ fontSize: "15px", textWrap: "nowrap" }}
                      >
                        Product Name
                      </th>
                      {/* <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer Name
                        </th>
                        <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Customer Type
                        </th> */}
                      <th
                        scope="col"
                        style={{ fontSize: "15px", textWrap: "nowrap" }}
                      >
                        Date & Time
                      </th>
                      {/* <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Quantity
                        </th> */}
                      <th
                        scope="col"
                        style={{ fontSize: "15px", textWrap: "nowrap" }}
                      >
                        Total Amount
                      </th>

                      <th
                        scope="col"
                        style={{ fontSize: "15px", textWrap: "nowrap" }}
                      >
                        Payment Status
                      </th>
                      {/* <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Delivery Address
                        </th> */}
                      <th
                        scope="col"
                        style={{ fontSize: "15px", textWrap: "nowrap" }}
                      >
                        Status
                      </th>
                      {/* <th
                          scope="col"
                          style={{ fontSize: "15px", textWrap: "nowrap" }}
                        >
                          Action
                        </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((order) => {
                        const isMulti = order.orderItems.length > 1;
                        const isExpanded = expandedRows.includes(order.id);

                        const isOverdue =
                          order?.orderItems[0]?.status.toLowerCase() ===
                          "need-approval";
                        return (
                          <React.Fragment key={order.id}>
                            <tr
                              className={isOverdue ? "overdue-row" : undefined}
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{ borderColor: "#c5d5f5" }}
                                  checked={selectedData.includes(order.id)}
                                  onChange={() => handleSelectOne(order.id)}
                                />
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    textWrap: "nowrap",
                                  }}
                                >
                                  {order.orderItems.length > 1 && (
                                    <button
                                      style={{
                                        border: "2px solid #006fbf",
                                        color: "#006fbf",
                                        background: "transparent",
                                        borderRadius: "4px",
                                        width: "14px",
                                        height: "14px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "12px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => toggleExpand(order.id)}
                                    >
                                      {isExpanded ? "−" : "+"}
                                    </button>
                                  )}
                                  <span>{formatOrderId(order)}</span>
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <button
                                  onClick={() =>
                                    handleOrderDetailClick(order.id)
                                  }
                                  style={{
                                    background: "none",
                                    border: "none",
                                    // color: "#006fbf",
                                    // textDecoration: "underline",
                                    cursor: "pointer",
                                    padding: 0,
                                    fontSize: "inherit",
                                  }}
                                  title="View Order Details"
                                >
                                  {isMulti ? (
                                    <>
                                      <span>
                                        {order.orderItems[0]?.productName}
                                      </span>
                                      <span className="text-primary">
                                        {" "}
                                        + {order.orderItems.length - 1} Items
                                      </span>
                                    </>
                                  ) : (
                                    <span>
                                      {order.orderItems[0]?.productName}
                                    </span>
                                  )}
                                </button>
                              </td>

                              {/* <td>
                                  <span>{order.name}</span>
                                </td>
                                <td>
                                  <span>
                                    {order.customerType
                                      ? `${order.customerType} (${
                                          order.customerType === "individual"
                                            ? "B2C"
                                            : "B2B"
                                        })`
                                      : "N/A"}
                                  </span>
                                </td> */}
                              <td>
                                <span>
                                  {formatShortMonthDateYearWithTime(
                                    order.createTimestamp,
                                  )}
                                </span>
                              </td>
                              {/* <td>
                                  <span>{order.totalItems}</span>
                                </td> */}
                              <td>
                                <span>
                                  ₹
                                  {Math.round(
                                    order.totalAmount,
                                  ).toLocaleString()}
                                </span>
                              </td>
                              <td>
                                {order.paymentStatus && (
                                  <CustomColoredDropdown
                                    value={order.paymentStatus}
                                    options={PAYMENT_OPTIONS}
                                    type="payment"
                                    disable={true}
                                  />
                                )}
                              </td>
                              {/* <td>
                                  <span>
                                    {order.address}, {order.locality},{" "}
                                    {order.city},{order.state}
                                  </span>
                                </td> */}
                              <td>
                                {!isMulti && order.orderItems[0]?.status && (
                                  <CustomColoredDropdown
                                    value={order.orderItems[0]?.status}
                                    options={STATUS_OPTIONS}
                                    type="status"
                                    disable={true}
                                  />
                                )}
                              </td>
                              {/* <td>
                                  {order.invoiceStatus === "yes" ? (
                                    <button
                                      disabled
                                      style={{
                                        minWidth: "120px",
                                        fontSize: "15px",
                                        color: "#007AC3",
                                        backgroundColor: "#D9EBFF",
                                        borderRadius: "6px",
                                        cursor: "not-allowed",
                                        opacity: 0.7,
                                      }}
                                    >
                                      Invoice Converted
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => convertToInvoice(order)}
                                      disabled={convertingOrderId === order.id} // ✅ disable during loading
                                      style={{
                                        minWidth: "120px",
                                        fontSize: "15px",
                                        color: "white",
                                        backgroundColor:
                                          convertingOrderId === order.id
                                            ? "#999"
                                            : "#2B95D3", // ✅ gray during loading
                                        borderRadius: "6px",
                                        cursor:
                                          convertingOrderId === order.id
                                            ? "not-allowed"
                                            : "pointer",
                                      }}
                                    >
                                      {convertingOrderId === order.id
                                        ? "Converting..."
                                        : "Convert to invoice"}
                                    </button>
                                  )}
                                </td> */}
                            </tr>
                            {isExpanded &&
                              order.orderItems.map((item, idx) => (
                                <tr key={item.id} className="bg-light">
                                  <td></td>
                                  <td style={{ paddingLeft: "30px" }}>
                                    {idx + 1}.
                                  </td>
                                  <td>{item.productName}</td>
                                  <td></td>

                                  {/* <td>{item.qty}</td> */}
                                  <td>
                                    ₹{Math.round(item.amount).toLocaleString()}
                                  </td>
                                  <td></td>
                                  <td>
                                    {item.status && (
                                      <CustomColoredDropdown
                                        value={item.status}
                                        options={STATUS_OPTIONS}
                                        type="status"
                                        disable={true}
                                      />
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="11" className="text-center py-3">
                          No orders found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="d-flex justify-content-between align-items-center mt-16 p-16">
                <div className="d-flex align-items-center">
                  <select
                    className="form-select d-inline-block w-auto"
                    value={itemsPerPage}
                    onChange={(e) => {
                      const val = e.target.value;
                      setItemsPerPage(val === "all" ? "all" : parseInt(val));
                      setCurrentPage(1);
                    }}
                    style={{
                      height: "34px",
                      fontSize: "14px",
                      minWidth: "70px",
                    }}
                  >
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="all">All</option>
                  </select>
                  <span className="ms-2">
                    Showing {showingFrom} to {showingTo} of{" "}
                    {filteredData.length} orders
                  </span>
                </div>
                <nav>
                  <ul className="pagination mt-0">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage - 1)}
                      >
                        &laquo;
                      </button>
                    </li>
                    {(() => {
                      const pagesToShow = 5;
                      let startPage = Math.max(
                        1,
                        currentPage - Math.floor(pagesToShow / 2),
                      );
                      let endPage = startPage + pagesToShow - 1;
                      if (endPage > totalPage) {
                        endPage = totalPage;
                        startPage = Math.max(1, endPage - pagesToShow + 1);
                      }
                      const pageNumbers = [];
                      for (let i = startPage; i <= endPage; i++) {
                        pageNumbers.push(i);
                      }
                      return pageNumbers.map((pageNum) => (
                        <li
                          key={pageNum}
                          className={`page-item ${
                            currentPage === pageNum ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(pageNum)}
                          >
                            {pageNum}
                          </button>
                        </li>
                      ));
                    })()}
                    <li
                      className={`page-item ${
                        currentPage === totalPage ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => paginate(currentPage + 1)}
                      >
                        &raquo;
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </>
        </section>
      </div>
    </>
  );
};

export default CustomerOrders;

//Filter Panel Component
const FilterPanel = ({
  filterValues,
  onFilterChange,
  onApply,
  onClear,
  categories,
  filteredBrands,filteredProducts
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "500px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "16px",
        maxHeight: "500px",
        overflowY: "auto",
        marginTop: "10px",
      }}
    >
      <div className="row g-3">
        {/* Time Period Selector */}
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.timePeriod}
            onChange={(e) => onFilterChange("timePeriod", e.target.value)}
          >
            <option value="">Time Period</option>
            <option value="all">All Time</option>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
            <option value="thisMonth">This Month</option>
            <option value="last3Months">Last 3 Months</option>
            <option value="thisYear">This Year</option>
            <option value="period"> Period</option>
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.paymentType}
            onChange={(e) => onFilterChange("paymentType", e.target.value)}
          >
            <option value="">Payment Type</option>
            <option value="cash">Cash</option>
            <option value="cheque">Cheque</option>
            <option value="credit-card">Credit Card</option>
            <option value="debit-card">Debit Card</option>
            <option value="net-banking">Net Banking</option>
            <option value="upi">UPI</option>
            <option value="neft">NEFT</option>
            <option value="rtgs">RTGS</option>
          </select>
        </div>

        {/* Conditional: Show fromDate & toDate only when "period" is selected */}
        {filterValues.timePeriod === "period" && (
          <>
            <div className="col-md-6">
              <input
                type={filterValues.fromDate ? "date" : "text"}
                className="form-control filter-input"
                placeholder="From Date"
                value={filterValues.fromDate}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!filterValues.fromDate) e.target.type = "text";
                }}
                onChange={(e) => onFilterChange("fromDate", e.target.value)}
              />
            </div>
            <div className="col-md-6">
              <input
                type={filterValues.toDate ? "date" : "text"}
                className="form-control filter-input"
                placeholder="To Date"
                value={filterValues.toDate}
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => {
                  if (!filterValues.toDate) e.target.type = "text";
                }}
                onChange={(e) => onFilterChange("toDate", e.target.value)}
              />
            </div>
          </>
        )}

        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.paymentStatus}
            onChange={(e) => onFilterChange("paymentStatus", e.target.value)}
          >
            <option value="">Payment Status</option>
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
            <option value="partially paid">Partially Paid</option>
          </select>
        </div>
        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.status}
            onChange={(e) => onFilterChange("status", e.target.value)}
          >
            <option value="">Ordered Status</option>
            <option value="ordered">Ordered</option>
            <option value="packed">Packed</option>
            <option value="shipped">Shipped</option>
            <option value="delivered">Delivered</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.categoryId || ""}
            onChange={(e) => onFilterChange("categoryId", e.target.value)}
          >
            <option value="">Category</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.brandId}
            onChange={(e) => onFilterChange("brandId", e.target.value)}
            disabled={!filterValues.categoryId && filteredBrands.length === 0}
          >
            <option value="">Brand</option>
            {filteredBrands.map((brand) => (
              <option key={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-6">
          <select
            className="form-select filter-input"
            value={filterValues.productId}
            onChange={(e) => onFilterChange("productId", e.target.value)}
          >
            <option value="">Product</option>
            {filteredProducts.map((product) => (
              <option key={product.id} value={product.id}>
                {product.name}{" "}
                {product.brandName ? `(${product.brandName})` : ""}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="d-flex gap-14 mt-24">
        <button
          onClick={onApply}
          style={{
            color: "#fff",
            backgroundColor: "#2b95d3",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
          }}
        >
          Apply Filters
        </button>
        <button
          onClick={onClear}
          style={{
            color: "#2692d2",
            backgroundColor: "#d9ebff",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "700",
            cursor: "pointer",
            padding: "8px 16px",
            minWidth: "150px",
            height: "40px",
            border: "none",
            gap: "6px",
          }}
        >
          Clear All
        </button>
      </div>
    </div>
  );
};


